/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderExportRequest
 */
export interface OrderExportRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderExportRequest
     */
    orderIds?: Array<string>;
}

/**
 * Check if a given object implements the OrderExportRequest interface.
 */
// @ts-ignore
export function instanceOfOrderExportRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

// @ts-ignore
export function OrderExportRequestFromJSON(json: any): OrderExportRequest {
    return OrderExportRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderExportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderExportRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderIds': !exists(json, 'order_ids') ? undefined : json['order_ids'],
    };
}

// @ts-ignore
export function OrderExportRequestToJSON(value?: OrderExportRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'order_ids': value.orderIds,
    };
}

